var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("settings-popup-base", {
    attrs: {
      resources: Object.assign(
        {},
        {
          deleteButtonText: _vm.resource(
            "JourneyBuilder_Button_DeleteCheckpoint"
          )
        },
        _vm.resources
      ),
      invalid: _vm.invalid
    },
    on: {
      hide: function($event) {
        return _vm.onHide($event)
      },
      hidden: function($event) {
        return _vm.$emit("hidden")
      },
      save: function($event) {
        return _vm.$emit("save")
      },
      delete: function($event) {
        return _vm.deleteCheckpointWithPrompt()
      },
      "display-errors": function($event) {
        return _vm.$emit("display-errors")
      }
    },
    scopedSlots: _vm._u(
      [
        {
          key: "title",
          fn: function() {
            return [_vm._t("title")]
          },
          proxy: true
        },
        {
          key: "body",
          fn: function() {
            return [
              _vm._t("body"),
              _vm._v(" "),
              _vm.canWrite && _vm.commentId
                ? [
                    _c("hr"),
                    _vm._v(" "),
                    _c("h4", [
                      _vm._v(
                        _vm._s(
                          _vm.resource(
                            "JourneyBuilder_JourneyBrick_CommentHeader"
                          )
                        )
                      )
                    ]),
                    _vm._v(" "),
                    _c("new-comment", {
                      attrs: { brickId: _vm.commentId, id: "newcomment" }
                    })
                  ]
                : _vm._e()
            ]
          },
          proxy: true
        }
      ],
      null,
      true
    )
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }